import { ACCENT_COLOR_TYPE, LIGHT_COLOR_TYPE, DARK_COLOR_TYPE } from '../constants/color-types';

function mapColorKeyToColorType(key) {
  if (key.startsWith('ws-light')) return LIGHT_COLOR_TYPE;
  if (key.startsWith('ws-dark')) return DARK_COLOR_TYPE;

  return ACCENT_COLOR_TYPE;
}

export default mapColorKeyToColorType;
